import { ActionsUnion, createAction } from "store/helper";

import { IFetchBillingInfoFailurePayload } from "./interfaces";

export enum BillingActionNames {
  FETCH_BILLING_INFO_REQUEST = "ENTITIES/BILLING/FETCH_BILLING_INFO_REQUEST",
  FETCH_BILLING_INFO_SUCCESS = "ENTITIES/BILLING/FETCH_BILLING_INFO_SUCCESS",
  FETCH_BILLING_INFO_FAILURE = "ENTITIES/BILLING/FETCH_BILLING_INFO_FAILURE",
  UPDATE_BILLING_INFO_SUCCESS = "ENTITIES/BILLING/UPDATE_BILLING_INFO_SUCCESS",
  UPDATE_BILLING_INFO_FAILURE = "ENTITIES/BILLING/UPDATE_BILLING_INFO_FAILURE",
  UPDATE_BILLING_INFO = "ENTITIES/BILLING/UPDATE_BILLING_INFO_REQUEST",
}

export enum BillingRequestFetchingSelectorsNames {
  FETCH_BILLING_INFO_REQUEST = "ENTITIES/BILLING/FETCH_BILLING_INFO",
  UPDATE_BILLING_INFO_REQUEST = "ENTITIES/BILLING/UPDATE_BILLING_INFO",
}

export const BillingActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchBillingInfo: () => createAction(BillingActionNames.FETCH_BILLING_INFO_REQUEST),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  fetchBillingInfoSuccess: (billingInfo: any) =>
    createAction(BillingActionNames.FETCH_BILLING_INFO_SUCCESS, billingInfo),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchBillingInfoFailure: (error: IFetchBillingInfoFailurePayload) =>
    createAction(BillingActionNames.FETCH_BILLING_INFO_FAILURE, error),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  updateBillingInfo: (payload: any) => createAction(BillingActionNames.UPDATE_BILLING_INFO, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  updateBillingInfoFailure: (payload: any) => createAction(BillingActionNames.UPDATE_BILLING_INFO_FAILURE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  updateBillingInfoSuccess: (billingInfo: any) =>
    createAction(BillingActionNames.UPDATE_BILLING_INFO_SUCCESS, billingInfo),
};

export type BillingActionTypes = ActionsUnion<typeof BillingActions>;
